import { useAppSelector, useAppDispatch } from "@/services/hooks";
import { useCurrentPermission } from "@/services/userServices/useCurrentPermission";
import React, { useEffect, useMemo, useState } from "react";

import { useParams } from "react-router-dom";

import {
  getProductPropertiesById,
  clearProductPropertiesById,
  updateProductproperties,
  clearMessage,
} from "@/services/productPropertiesServices/ProductPropertiesActions";

import NotificationAlertOptions from "@/layouts/Alerts";

import UpdateProductPropertiesView from "./UpdateProductPropertiesView";
import type { ProductPropertiesRecord, ProductPropertyValue } from "./UpdateProductPropertiesView";

const UpdateProductPropertiesContainer = () => {
  const dispatch = useAppDispatch();
  const { id } = useParams();

  // SCRUM-771: per-slice selectors (object-literal selector re-rendered on every dispatch).
  const productPropsFromStore = useAppSelector((s) => s.productproperties.productpropertiesbyid);
  const message = useAppSelector((s) => s.productproperties.message);
  const permission = useCurrentPermission();


  const [productProps, setProductProps] = useState<ProductPropertiesRecord | null>(null);


  useEffect(() => {
    if (!id) return;
    dispatch(getProductPropertiesById(id));
    return () => {
      dispatch(clearProductPropertiesById());
    };
  }, [dispatch, id]);

 
  useEffect(() => {
    if (productPropsFromStore) setProductProps(productPropsFromStore);
  }, [productPropsFromStore]);

  
  useEffect(() => {
    if (message) {
      NotificationAlertOptions("success", message);
      dispatch(clearMessage());
    }
  }, [message, dispatch]);


  const handleFieldChange = (name: string, value: ProductPropertyValue) => {
    if (!productProps?.properties) return;
    const properties = productProps.properties.map((p) =>
      p.name === name ? { ...p, value } : p
    );
    setProductProps((prev) => ({ ...prev, properties }));
  };

  const handleUpdate = () => {
    if (productProps) dispatch(updateProductproperties(productProps));
  };

  const product = productProps?.product;
  const subcategory = productProps?.subcategory;

  const canEdit = useMemo(
    () => !!(permission?.edit || permission?.publish),
    [permission]
  );

  return (
    <UpdateProductPropertiesView
      productProps={productProps}
      product={product}
      subcategory={subcategory}
      canEdit={canEdit}
      // handlers
      onFieldChange={handleFieldChange}
      onUpdate={handleUpdate}
      onBackToListHref="/admin/productproperties"
    />
  );
};

export default UpdateProductPropertiesContainer;
